export default function AboutCreator() {
  return (
    <section
      id="about"
      data-testid="about-creator"
      className="bg-[#FFFFFF] border-b border-[#E5E0D8]"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-start">
          <div className="col-span-12 md:col-span-5" data-reveal>
            <div className="relative border border-[#E5E0D8]">
              <img
                src="https://customer-assets.emergentagent.com/job_five-min-formula/artifacts/wojkimz1_SP147%20copy.jpg"
                alt="Maria-Katharina Richters in her garden"
                className="w-full h-[520px] object-cover"
                data-testid="creator-portrait"
              />
              <div className="absolute -bottom-3 -right-3 bg-[#1FA5B8] text-[#F7F5F2] px-4 py-2 font-body text-[11px] uppercase tracking-[0.28em]">
                Founder · The Academy
              </div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-6 md:col-start-7" data-reveal>
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#1FA5B8] font-body">
              About the academy
            </div>
            <h2 className="mt-4 font-display text-[#1A1A1A] leading-[1.05] tracking-tight text-[clamp(2.25rem,4.4vw,3.5rem)] font-medium">
              Creativity is what{" "}
              <span className="italic font-light">brought</span> me back to
              myself.
            </h2>

            <div className="mt-8 space-y-5 font-body text-[#1A1A1A] text-[17px] leading-[1.75] max-w-xl">
              <p>
                I&apos;m Maria-Katharina Richters. I lost my creativity because
                I didn&apos;t know myself, and so I didn&apos;t know how to
                love myself. Underneath, I hadn&apos;t yet found a real
                connection to life, the kind I would only come to understand
                later. What followed is what many of us experience in some
                form. Attachments, unhealthy habits, limiting beliefs, the
                pull of instant gratification. For me, it went as far as
                addiction and unstable relationship dynamics, until I had to
                face it all.
              </p>
              <p>
                What carried me through was creativity, alongside a stronger
                mindset and a real shift in consciousness. Painting, sketching
                clothes, music, and the ancient wisdom of Kabbalah, which
                taught me that creativity isn&apos;t a hobby or a pleasant
                extra. It&apos;s essential. A way of living in joy and
                abundance, from the inside out.
              </p>
              <p>
                That&apos;s why I share it. Instant gratification reaches
                outward for a short, loud boost. Creativity grows quietly
                inward, and lasts. Not just creativity with art, but with how
                you live, choose, and meet your own life. I now work as a
                coach, sound healer and art therapist, and this Academy is
                where that work lives.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-xl">
              <Stat n="Coach" label="Coaching" />
              <Stat n="Healer" label="Sound" />
              <Stat n="Therapist" label="Art" />
              <Stat n="Artist" label="Nature" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ n, label }) {
  return (
    <div data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`} className="border-t border-[#1A1A1A] pt-4">
      <div className="font-display text-[26px] leading-none tracking-tight text-[#1A1A1A]">
        {n}
      </div>
      <div className="mt-2 font-body text-[11px] uppercase tracking-[0.22em] text-[#5C5C5C]">
        {label}
      </div>
    </div>
  );
}
